import { ChangeDetectorRef, Component, Input } from "@angular/core";
import { CoreService } from "../services/core.service";
import { combineLatest } from "rxjs";
import { selectPropertyById } from "../store/properties.selectors";
import { take } from "rxjs/operators";
import { Store } from "@ngrx/store";
import { AppState } from "../core.state";
import { CommonModule } from "@angular/common";

@Component({
    selector: 'charla-message-article',
    templateUrl: './message-article.component.html',
    styleUrls: ['./message-article.component.scss'],
    imports: [CommonModule]
})
export class MessageArticleComponent {

    @Input() id: number;
    title: string;
    desc: string;
    slug: string;
    use_kb_links: boolean = false;
    kb_base: string = "";

    constructor(
            private cd: ChangeDetectorRef,
            private api: CoreService,
            private store: Store<AppState>,
        ){
    }

    ngOnInit() {

        this.api.getArticle(this.id, true).subscribe(res => {            
            this.title = res.model.title;
            this.desc= res.model.description;
            this.slug = res.model.slug;

            this.store.select(selectPropertyById({property_id: res.model.property_id}))
                .pipe(take(1))
                .subscribe(p => {
                    this.use_kb_links = p.is_kb_links_helpcenter;
                    this.kb_base = p.kb_helpcenter_url
                });

            this.cd.detectChanges();
        });
        
    }

    open_article(event){

        if (this.use_kb_links){
            window.open(this.kb_base + "?article=" + this.id + "-" + this.slug );
        } else {
            window.open(
                "/api/kb/view/" + this.id + "/" + this.slug,
                "charla-article",
                "scrollbars=yes,resizable=yes,status=no,location=no,toolbar=no,menubar=no,width=500,height=700,left=900,top=200"
            ); 
        }

        event.preventDefault();
        return false;
    }

    build_url(){

        if (this.use_kb_links){
            return `${this.kb_base}?article=${this.id}-${this.slug}`;
        } else {
            return `/api/kb/view/${this.id}/${this.slug}`;
        }

    }

}

